<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("FnB Sales Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
                :multiple="true"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getFnBSalesReport({ isPdf: 'N', isExcel: 'N' })"
            >
              {{ $t("fetch") }}
              <!-- {{ $t("report") }} -->
            </button>
          </div>

          <div
            v-if="fnbSalesRecords.length > 0"
            class="col-lg-6 col-xl-3 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <a
              href="#"
              @click="getFnBSalesReport({ isPdf: 'Y', isExcel: 'N' })"
              title="Download as Pdf"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              href="#"
              @click="getFnBSalesReport({ isPdf: 'N', isExcel: 'Y' })"
              title="Download as Excel"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Payment Type</th>
            <th>Item Name</th>
            <th>Category</th>
            <th>Qty</th>
            <th>Sale Value%</th>
            <th>Sale Value</th>
            <th>Qty%</th>
            <th>Purchase Value</th>
            <th>VAT</th>
            <th>Net Sales</th>
          </thead>
          <!-- <tr class="bg-lightgrey font-weight-bold">
            <th>Item Name</th>
            <th>Payment Type</th>
          </tr> -->
          <!-- <tr class="bg-lightgrey font-weight-bold">
            <td rowspan="2">Item Name</td>
            <td rowspan="2">Payment Type</td>
            <template v-for="(fnbSalesData, fnbSalesIndex) in fnbSalesRecords">
              <td colspan="7" :key="fnbSalesIndex + 'column_headers_cinema'">
                {{ fnbSalesData.cinema_name }}
              </td>
            </template>
          </tr>

          <tr class="bg-lightgrey font-weight-bold">
            <template v-for="(fnbSalesData, fnbSalesIndex) in fnbSalesRecords">
              <td :key="fnbSalesIndex + 'column_headers'">Qty</td>
              <td :key="fnbSalesIndex + 'column_headers'">Sale Value%</td>
              <td :key="fnbSalesIndex + 'column_headers'">Sale Value</td>
              <td :key="fnbSalesIndex + 'column_headers'">Qty%</td>
              <td :key="fnbSalesIndex + 'column_headers'">Purchase Value</td>
              <td :key="fnbSalesIndex + 'column_headers'">VAT</td>
              <td :key="fnbSalesIndex + 'column_headers'">Net Sales</td>
            </template>
          </tr> -->
          <!-- <template v-for="(fnbSalesData, fnbSalesIndex) in fnbSalesRecords">
            <tr :key="fnb_salesIndex + 'fnb_header'">
              <th>Qty</th>
              <th>Sale Value%</th>
              <th>Sale Value</th>
              <th>Qty%</th>
              <th>Purchase Value</th>
              <th>VAT</th>
              <th>Net Sales</th>
            </tr>
          </template> -->
          <tbody v-if="fnbSalesRecords.length > 0">
            <template v-for="(fnbSalesData, fnbSalesIndex) in fnbSalesRecords">
              <tr :key="fnbSalesIndex + '-cinema_name'">
                <td
                  class="text-center bg-lightgrey font-weight-bold"
                  colspan="10"
                >
                  {{ fnbSalesData.cinema_name }}
                </td>
              </tr>
              <template
                v-for="(fnb_sales, fnb_salesIndex) in fnbSalesData.fnbSales"
              >
                <tr :key="fnb_salesIndex + '-fnb_data'">
                  <td class="text-left">{{ fnb_sales.pm_payment_mode }}</td>
                  <td class="text-left">{{ fnb_sales.fst_item_name }}</td>
                  <td class="text-left">{{ fnb_sales.fc_category }}</td>
                  <td class="text-right">{{ fnb_sales.quantity }}</td>
                  <td class="text-right">
                    {{
                      currFormat(
                        parseFloat(
                          (fnb_sales.sales / fnbSalesData.sales_total) * 100
                        )
                      ) || 0
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnb_sales.sales) || 0 }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        parseFloat(
                          (fnb_sales.quantity / fnbSalesData.qty_total) * 100
                        )
                      ) || 0
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnb_sales.purchase) || 0 }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        parseFloat(fnb_sales.sales - fnb_sales.net_sales)
                      ) || 0
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnb_sales.net_sales) || 0 }}
                  </td>
                </tr>
              </template>
              <template>
                <tr
                  :key="fnbSalesIndex + 'grand_total'"
                  class="font-weight-bold bg-lightgrey"
                >
                  <td colspan="3">Grand Total</td>
                  <td class="text-right">
                    {{ fnbSalesData.qty_total }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.sales_avg) || 0 }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.sales_total) || 0 }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.qty_avg) || 0 }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.purchase_total) || 0 }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.tax_total) || 0 }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(fnbSalesData.net_sales_total) || 0 }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="section-title my-3">
          {{ $t("FnB Summary Report") }}
        </div>
        <div
          v-if="fnbSalesRecords.length > 0"
          class="d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->
          <a
            href="#"
            @click="getFnbSalesSummaryReport({ isPdf: 'Y', isExcel: 'N' })"
            title="Download as Pdf"
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
          <a
            href="#"
            @click="generateReport('excel')"
            title="Download as Excel"
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Online</th>
            <th>Offline</th>
            <th>Total</th>
          </thead>
          <tbody v-if="fnbSummaryRecords.length > 0">
            <template
              v-for="(fnbSummaryObj, fnbSummaryIndex) in fnbSummaryRecords"
            >
              <tr :key="fnbSummaryIndex + fnbSummaryObj.cinema_name">
                <td
                  class="text-center bg-lightgrey font-weight-bold"
                  colspan="5"
                >
                  {{ fnbSummaryObj.cinema_name }}
                </td>
              </tr>

              <tr
                v-for="(fnbData, fnbDataIndex) in fnbSummaryObj.fnbDataArr"
                :key="fnbDataIndex + '-fnb_data' + fnbSummaryIndex.cinema_name"
              >
                <td class="text-left">{{ fnbData.item_name }}</td>
                <td class="text-right">{{ fnbData.quantity }}</td>
                <td class="text-right">{{ currFormat(fnbData.online) }}</td>
                <td class="text-right">{{ currFormat(fnbData.offline) }}</td>
                <td class="text-right">{{ currFormat(fnbData.total) }}</td>
              </tr>
              <tr
                class="bg-lightgrey"
                :key="
                  fnbSummaryIndex + fnbDataIndex + fnbSummaryIndex.cinema_name
                "
              >
                <td class="text-left">Total</td>
                <td class="text-right">
                  {{
                    fnbSummaryObj.fnbDataArr.reduce((acc, { quantity }) => {
                      return acc + +parseFloat(quantity);
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      fnbSummaryObj.fnbDataArr.reduce((acc, { online }) => {
                        return acc + +parseFloat(online);
                      }, 0)
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      fnbSummaryObj.fnbDataArr.reduce((acc, { offline }) => {
                        return acc + +parseFloat(offline);
                      }, 0)
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      fnbSummaryObj.fnbDataArr.reduce((acc, { total }) => {
                        return acc + +parseFloat(total);
                      }, 0)
                    )
                  }}
                </td>
              </tr>
            </template>
            <tr class="bg-lightgrey">
              <td class="text-left">Grand Total</td>
              <td class="text-right">{{ fnbSummaryGrandTotal.quantity }}</td>
              <td class="text-right">
                {{ currFormat(fnbSummaryGrandTotal.online) }}
              </td>
              <td class="text-right">
                {{ currFormat(fnbSummaryGrandTotal.offline) }}
              </td>
              <td class="text-right">
                {{ currFormat(fnbSummaryGrandTotal.total) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      fnbSalesRecords: [],
      fnbSummaryRecords: [],
      fnbSummaryGrandTotal: {},
      excelFilePath: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },

  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      console.log(this.dropDown.selectedCinema);
      this.dropDown.selectedCinema = event;
      // this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaName = event
        .map((cinema) => cinema.cine_name)
        .join(", ");
      // this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getFnbSalesSummaryReport({ isPdf, isExcel }) {
      this.fnbSummaryRecords = [];
      if (this.dropDown.selectedCinema.length == 0) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader;
      loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinema.map(
          (cinema_elem) => cinema_elem.cine_id
        ),
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.map(
          (cinema_elem) => cinema_elem.cine_address || ""
        ),
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
        isExcel,
      };
      ReportsService.getFnbSummaryReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.fnbSummaryRecords = [...data.Records];
            this.fnbSummaryGrandTotal = { ...data.grandTotal };
            this.$toasted.show(data.message);
            if (data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError);
    },
    generateReport(type) {
      let isPdf = type === "pdf" ? "Y" : "N";
      let isExcel = type === "excel" ? "Y" : "N";
      this.getFnBSalesReport({ isPdf, isExcel });
    },
    getFnBSalesReport({ isPdf, isExcel }) {
      this.fnbSalesRecords = [];
      if (this.dropDown.selectedCinema.length == 0) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinema.map(
          (cinema_elem) => cinema_elem.cine_id
        ),
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.map(
          (cinema_elem) => cinema_elem.cine_address || ""
        ),
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        summaryData: this.fnbSummaryRecords,
        isPdf: isPdf,
        excel: isExcel,
      };
      ReportsService.GetFnBSalesReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.fnbSalesRecords = [...data.Records];
            this.$toasted.show(data.message);
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .then(() => {
          this.getFnbSalesSummaryReport({ isPdf: "N", isExcel: "N" });
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbSalesReport.vue